<ins 
    class="adsbygoogle" 
    data-ad-format="auto"
    data-full-width-responsive="true"
    style="display:block;height:250px"
    [attr.data-ad-slot]="adSlot" 
    [attr.data-ad-client]="adClient" 
></ins>
